import React, { useEffect, useState, useRef } from 'react';
function useInView(threshold = 0.15) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setInView(true);
    }, {
      threshold
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);
  return {
    ref,
    inView
  };
}
export function StorySection() {
  const {
    ref: ref1,
    inView: in1
  } = useInView();
  const {
    ref: ref2,
    inView: in2
  } = useInView();
  const {
    ref: ref3,
    inView: in3
  } = useInView();
  const {
    ref: ref4,
    inView: in4
  } = useInView();
  return <section style={{
    backgroundColor: 'var(--color-white-warm)'
  }} className="py-20 px-6" data-id="element-65">
      <div className="max-w-2xl mx-auto" data-id="element-66">
        {/* Opening scene */}
        <div ref={ref1} className={`transition-all duration-700 ${in1 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-67">
          <p className="font-serif text-xl sm:text-2xl italic leading-relaxed mb-8 text-center" style={{
          color: 'var(--color-text-mid)'
        }} data-id="element-68">
            "Estás en la cocina. El bebé lleva 20 minutos llorando. No has
            dormido más de 3 horas seguidas en semanas. Miras la pila de platos,
            la ropa sin lavar y, de repente, sientes ese nudo en la garganta."
          </p>
        </div>

        {/* Emotional punch line */}
        <div ref={ref2} className={`transition-all duration-700 delay-100 ${in2 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-69">
          <p className="font-serif text-2xl sm:text-3xl font-bold text-center leading-tight mb-10" style={{
          color: 'var(--color-burgundy)'
        }} data-id="element-70">
            Quieres gritar. Y luego, te sientes la peor madre del mundo por
            querer hacerlo.
          </p>

          <div className="h-px w-24 mx-auto mb-10 opacity-30" style={{
          backgroundColor: 'var(--color-terracotta)'
        }} data-id="element-71" />

          <p className="font-sans text-base sm:text-lg leading-relaxed mb-6" style={{
          color: 'var(--color-text-mid)'
        }} data-id="element-72">
            Te dijeron que la maternidad era "una bendición", que tenías que
            "aprovechar cada segundo porque crecen rápido". Pero nadie te dijo
            que en este país, sin la abuela para pasarte un café o la tía para
            cargar al bebé mientras te bañas, la bendición se siente como una
            celda de cansancio infinito.
          </p>

          <p className="font-sans text-base sm:text-lg leading-relaxed mb-12" style={{
          color: 'var(--color-text-mid)'
        }} data-id="element-73">
            Y lo peor: cada vez que pides ayuda, sientes que estás fallando. Que
            las demás madres lo hacen solas. Que tú deberías poder también.
          </p>
        </div>

        {/* Marianismo box */}
        <div ref={ref3} className={`transition-all duration-700 delay-150 ${in3 ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`} data-id="element-74">
          <div className="rounded-2xl p-8 sm:p-10 text-center mb-12" style={{
          backgroundColor: 'var(--color-burgundy)',
          boxShadow: '0 20px 60px rgba(123, 45, 62, 0.25)'
        }} data-id="element-75">
            <p className="font-sans text-sm font-semibold uppercase tracking-widest mb-4 opacity-80" style={{
            color: 'var(--color-gold-light, #E8C47A)'
          }} data-id="element-76">
              La culpa que sientes tiene un nombre:
            </p>
            <h2 className="font-serif text-4xl sm:text-5xl font-black mb-4" style={{
            color: '#fff'
          }} data-id="element-77">
              EL MARIANISMO
            </h2>
            <p className="font-serif text-lg sm:text-xl italic" style={{
            color: 'rgba(255,255,255,0.85)'
          }} data-id="element-78">
              Esa idea de que si no sufres, no eres buena madre.
            </p>
            <div className="mt-6 pt-6 border-t border-white border-opacity-20" data-id="element-79">
              <p className="font-serif text-2xl sm:text-3xl font-bold" style={{
              color: 'var(--color-gold)'
            }} data-id="element-80">
                Es Mentira.
              </p>
            </div>
          </div>
        </div>

        {/* Resolution */}
        <div ref={ref4} className={`transition-all duration-700 delay-100 ${in4 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-81">
          <p className="font-sans text-base sm:text-lg leading-relaxed mb-6 text-center" style={{
          color: 'var(--color-text-mid)'
        }} data-id="element-82">
            Tu bebé no necesita una madre perfecta que esté al borde del
            colapso.
          </p>
          <p className="font-serif text-2xl sm:text-3xl font-bold text-center" style={{
          color: 'var(--color-text-dark)'
        }} data-id="element-83">
            Tu bebé necesita una madre{' '}
            <span style={{
            color: 'var(--color-terracotta)'
          }} data-id="element-84">
              REGULADA.
            </span>
          </p>
        </div>
      </div>
    </section>;
}